import { parseAndSanitizeString, parseAndSanitizeStringNoTrim, } from "../utils/sanitize-string.js";
export function parseStringValue(value, opts) {
    const parsedValue = parseAndSanitizeString(value);
    if (opts.required && !parsedValue) {
        return {
            isValid: false,
            error: opts.required === true ? opts.message : opts.required.message,
        };
    }
    return {
        isValid: true,
        value: parsedValue,
    };
}
export function parseStringValueNoTrim(value, opts) {
    const parsedValue = parseAndSanitizeStringNoTrim(value);
    if (opts.required && !parsedValue) {
        return {
            isValid: false,
            error: opts.required === true ? opts.message : opts.required.message,
        };
    }
    return {
        isValid: true,
        value: parsedValue,
    };
}
